@if (workspaces[this.ppWorkspaceId]?.sitePlan) {
  <div
    #planElement
    data-m-target="Point site plan"
    class="point__site-plan-preview"
    [class.point__site-plan-preview--active]="activePlan.active"
    [class.point__site-plan-preview--full]="ppFull"
    [class.point__site-plan-preview--half]="!ppFull"
    data-test="pointSitePlan"
    >
    <div
      class="plan__preview-container"
      (click)="activatePlan($event)"
      (touchend)="onTouchEnd($event)"
      >
      <div class="plan__preview" (ppOnRendered)="onPlanContainerRendered()">
        @if (planRendered) {
          <pp-plan
            [ppModule]="EPlanModule.POINT"
            [class.plan__preview--active]="activePlan.active"
            [ppWorkspaceId]="ppWorkspaceId"
            [ppPointId]="ppPointId"
            [ppHalfModal]="true"
            [ppCanEdit]="ppCanEdit"
            [ppActive]="activePlan.active"
          ></pp-plan>
        }
      </div>
    </div>
    <div class="point__site-plan-button-container">
      @if (activeButtons && ppPointId !== NEW_POINT_ID && ppCanEdit && !activePlan.drawingPolygon) {
        <pp-button
          ppStyle="primary"
          ppId="saveAccTypeBtn"
          (ppAction)="save()"
          ppSize="small"
          [ppProcess]="updatingPlan"
          >
          {{ noLocation ? 'Confirm' : 'Confirm location' }}
        </pp-button>
      }
      @if (activeButtons && ppPointId !== NEW_POINT_ID && ppCanEdit && !activePlan.drawingPolygon) {
        <pp-button
          ppStyle="secondary"
          ppId="saveAccTypeBtn"
          (ppAction)="cancel()"
          ppSize="small"
          >
          {{ 'cancel' | ppTranslate }}
        </pp-button>
      }
    </div>
    <div
      #deleteIcon
      id="deleteIcon"
      class="point__site-plan-delete"
      [class.point__site-plan-delete--visible]="deleteIconVisible"
    (drop)="
      mode === EPlanPointMode.POLYGON || mode === EPlanPointMode.DRAW
        ? deleteVertice(verticeToDelete)
        : deleteFeature()
    "
    (mouseup)="
      mode === EPlanPointMode.POLYGON || mode === EPlanPointMode.DRAW
        ? deleteVertice(verticeToDelete)
        : deleteFeature()
    "
    (dragend)="
      mode === EPlanPointMode.POLYGON || mode === EPlanPointMode.DRAW
        ? deleteVertice(verticeToDelete)
        : deleteFeature()
    "
      >
      <div class="point__site-plan-delete-icon"></div>
    </div>
    @if (showingPrompt && ppCanEdit && mode === EPlanPointMode.POINT && activePlan.active) {
      <div
        class="point__site-plan-prompt point__site-plan-prompt--long point__site-plan-prompt--pins"
        (click)="hidePrompt()"
        >
        <h6 class="point__site-plan-prompt-text">
          {{ 'click_or_tap_plan_to_add_pins' | ppTranslate }} <br />
          {{ 'drag_and_drop_to_edit_pin_location' | ppTranslate }}
        </h6>
      </div>
    }
    @if (showingSaveWarningPrompt && ppCanEdit && activePlan.active) {
      <div
        class="point__site-plan-prompt point__site-plan-prompt--long"
        (click)="hideSaveWarningPrompt()"
        >
        <h6 class="point__site-plan-prompt-text">
          {{ 'make_sure_closed_area' | ppTranslate }}
        </h6>
      </div>
    }
    @if (showingPrompt && ppCanEdit && mode === EPlanPointMode.DRAW && activePlan.active) {
      <div
        class="point__site-plan-prompt point__site-plan-prompt--long point__site-plan-prompt--area"
        (click)="hidePrompt()"
        >
        <h6 class="point__site-plan-prompt-text">
          {{ 'click_or_tap_plan_to_start_area' | ppTranslate }}
        </h6>
      </div>
    }
    @if (showingPrompt && ppCanEdit && mode === EPlanPointMode.POLYGON && activePlan.active) {
      <div
        class="point__site-plan-prompt point__site-plan-prompt--long point__site-plan-prompt--info"
        (click)="hidePrompt()"
        >
        <h6 class="point__site-plan-prompt-text">
          {{ 'edit_area_description' | ppTranslate }}
        </h6>
      </div>
    }
    @if (
      clickedPinCoordinates &&
      clickedPinCoordinates[0] &&
      clickedPinCoordinates[1] &&
      featureClicked.clicked &&
      activePlan.active
      ) {
      <div
        class="pinDropdown"
    [ngStyle]="{
      'top.px': clickedPinCoordinates[1] - 45,
      'left.px': clickedPinCoordinates[0] - 60
    }"
        (click)="deleteFeature(true)"
        >
        <span class="pinDropdown__text"> {{ 'delete_pin' | ppTranslate }} </span>
      </div>
    }
    @if (
      clickedVertice &&
      clickedVerticeCoordinates[0] &&
      clickedVerticeCoordinates[1] &&
      activePlan.active
      ) {
      <div
        class="pinDropdown"
        [ngStyle]="{ 'top.px': clickedCoordinates[1] - 45, 'left.px': clickedCoordinates[0] - 60 }"
        (click)="deleteVertice()"
        >
        <span class="pinDropdown__text"> {{ 'delete_pin' | ppTranslate }} </span>
      </div>
    }
    @if (
      polygonClickedCoordinates &&
      polygonClickedCoordinates[0] &&
      polygonClickedCoordinates[1] &&
      polygonClicked &&
      activePlan.active
      ) {
      <div
        class="pinDropdown"
    [ngStyle]="{
      'top.px': polygonClickedCoordinates[1] - 45,
      'left.px': polygonClickedCoordinates[0] - 60
    }"
        (click)="deleteArea()"
        >
        <span class="pinDropdown__text"> {{ 'delete_area' | ppTranslate }} </span>
      </div>
    }
    @if (activePlan.drawingPolygon && activePlan.active) {
      <div
        class="point__site-plan-prompt point__site-plan-prompt--long point__site-plan-prompt--area"
        (click)="hidePrompt(); activePlan.drawingPolygon = false"
        >
        <h6 class="point__site-plan-prompt-text">
          {{ 'complete_area_description' | ppTranslate }}
        </h6>
      </div>
    }
    @if (activePlan.active && ppCanEdit) {
      <div class="point__site-plan-mode">
        <div class="point__site-plan-mode-options">
          <div
            ppTooltip
            [ppTitle]="mode === EPlanPointMode.POLYGON ? 'Select an area' : 'Switch to areas'"
            [ppOptions]="{ placement: 'right' }"
            class="point__site-plan-mode-option"
        [class.point__site-plan-mode-option--active]="
          mode === EPlanPointMode.POLYGON || mode === EPlanPointMode.DRAW
        "
            (click)="switchMode($event, EPlanPointMode.DRAW)"
            >
            <div
              class="point__site-plan-mode-option--image point__site-plan-mode-option--image-polygon"
              >
              <pp-icon
                [ppDisplayContents]="true"
                [ppSrc]="EIconPath.ICON_SITE_PLAN_AREA_14"
            [ppColor]="
              mode === EPlanPointMode.POLYGON || mode === EPlanPointMode.DRAW
                ? 'primary-600'
                : 'grey-600'
            "
              ></pp-icon>
            </div>
          </div>
          <div
            ppTooltip
            [ppTitle]="mode === EPlanPointMode.POINT ? 'Drop a pin' : 'Switch to pins'"
            [ppOptions]="{ placement: 'right' }"
            class="point__site-plan-mode-option"
            [class.point__site-plan-mode-option--active]="mode === 'Point'"
            (click)="switchMode($event, EPlanPointMode.POINT)"
            >
            <div class="point__site-plan-mode-option--image point__site-plan-mode-option--image-pin">
              <pp-icon
                [ppDisplayContents]="true"
                [ppSrc]="EIconPath.ICON_SITE_PLAN_PIN_14"
                [ppColor]="mode === EPlanPointMode.POINT ? 'primary-600' : 'grey-600'"
              ></pp-icon>
            </div>
          </div>
        </div>
        @if (plan.point && (plan.point.polygons[0] || plan.point.pins[0])) {
          <div
            ppTooltip
            ppTitle="Clear all"
            [ppOptions]="{ placement: 'right' }"
            class="point__site-plan-mode-delete"
            [class.point__site-plan-mode-option--active]="true"
            (click)="clearAll()"
            >
            <img
              class="point__site-plan-mode-option--image point__site-plan-mode-option--image-polygon"
              [src]="EIconPath.INTERACTION_DELETE_ATTACHMENT_ICON"
              />
          </div>
        }
      </div>
    }
    @if (showUndoDelete) {
      <div
        class="point__site-plan-prompt point__site-plan-prompt--clickable"
        (click)="undoDelete()"
        >
        <div class="point__prompt-container">
          <h6 class="point__site-plan-prompt-text">{{ 'pin_deleted' | ppTranslate }} -</h6>
          <h6 class="point__site-plan-prompt-text point__site-plan-prompt-text--undo">
            {{ 'undo' | ppTranslate }}
          </h6>
        </div>
      </div>
    }
    @if (locationSaved) {
      <i class="fas fa-check sitePlan__saved-check" aria-hidden="true"></i>
    }
  </div>
}
